const HelpAndSupport = () =>{
    return (
        <div>
            <h4 className="font-semibold mb-4 text-[18px]">Coming Soon !</h4>
        </div>
    )
}

export default HelpAndSupport ;